/** What counts as a picture when one is read back. */
export const imageMediaTypes: { [key: string]: string[] } = {
    'image/webp': ['.webp'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/gif': ['.gif'],
    'image/svg+xml': ['.svg'],
};

/**
 * What a picker may offer.
 *
 * The server refuses an SVG (MimeTypes::UPLOADABLE_IMAGE_TYPES), so offering it
 * only led to choosing a file and being turned away afterwards (#1805). Reading
 * one back stays possible — see imageMediaTypes.
 */
export const uploadableImageMediaTypes: { [key: string]: string[] } = {
    'image/webp': ['.webp'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/gif': ['.gif'],
};
